module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"emptyList":"No path to display","trainingPathDashboard":"Progress of paths","trainingPaths":"path(s)"},"fr":{"emptyList":"Aucun parcours à afficher","trainingPathDashboard":"Avancement des parcours","trainingPaths":"parcours"}}')
  delete Component.options._Ctor
}
